export default "__VITE_ASSET__e4490087__"